var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/map",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8124718,0.625043809 C14.666736,0.625043809 16.9804283,2.93873611 16.9804283,5.79300024 C16.9804283,8.10052419 13.6028156,12.3062579 12.3087437,13.8328447 C12.0470694,14.1421033 11.5782748,14.1421033 11.3162,13.8328447 C10.0221281,12.3062579 6.64451541,8.10052419 6.64451541,5.79300024 C6.64451541,2.93873611 8.95820771,0.625043809 11.8124718,0.625043809 Z M11.8124718,7.51565238 C12.7640401,7.51565238 13.535124,6.74456848 13.535124,5.79300024 C13.535124,4.841432 12.7640401,4.0703481 11.8124718,4.0703481 C10.8609036,4.0703481 10.0898197,4.841432 10.0898197,5.79300024 C10.0898197,6.74456848 10.8609036,7.51565238 11.8124718,7.51565238 Z M0.825237214,9.48235492 L5.6909044,7.53616014 C5.90335201,8.14646638 6.1999135,8.78469042 6.56248435,9.44009771 L6.56248435,19 L0.899898291,21.5774093 C0.468794659,21.7496825 0,21.4322128 0,20.9679442 L0,10.7009246 C0.000120162677,10.2104206 0.369820667,9.66452154 0.825237214,9.48235492 Z M11.8124718,15.3770953 C12.3895731,15.3770953 12.9354722,15.1236321 13.3099391,14.6818741 C14.1167113,13.7303058 14.9739519,12.6462783 15.7499624,11.535174 L15.7499624,21.6245932 L7.87498122,18.9995995 L7.87498122,11.5347735 C8.6509918,12.6462783 9.50863288,13.7299053 10.3150046,14.6814735 C10.6894715,15.1236321 11.2353706,15.3770953 11.8124718,15.3770953 Z M22.7250454,7.23511258 C23.156149,7.06283936 23.6249437,7.38030915 23.6249437,7.84457768 L23.6249437,18.1115973 C23.6249437,18.6021814 23.2552432,19.1480805 22.7997065,19.330167 L17.0624593,21.6249937 L17.0624593,9.8125219 L22.7250454,7.23511258 Z",
    id: "map",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.e2d47d95.svg";
export { ForwardRef as ReactComponent };